import React from 'react';
import type { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';

import { ImageCard, type ImageCardProps } from './ImageCard';

type ImageCardSortableProps = {
  id: UniqueIdentifier;
  index: number;
  // eslint-disable-next-line react/boolean-prop-naming
  useDragOverlay?: boolean;
  onRemove: ImageCardProps['onRemove'];
  getWrapperStyle: (index: number) => React.CSSProperties;
  image: ImageCardProps['image'];
  onEdit: ImageCardProps['onEdit'];
};

export const ImageCardSortable = (props: ImageCardSortableProps) => {
  const { id, index, getWrapperStyle, ...restProps } = props;
  const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({
    id,
  });

  return (
    <ImageCard
      ref={setNodeRef}
      dragging={isDragging}
      transform={transform}
      transition={transition}
      wrapperStyle={getWrapperStyle?.(index)}
      listeners={listeners}
      data-index={index}
      data-id={id}
      {...restProps}
      {...attributes}
    />
  );
};
